import { isNil } from 'lodash';
import validTlds from 'tld-list';

const validProtocols = ['http:', 'https:'];

interface ValidateUrlOptions {
  allowLocalhost?: boolean;
}

const isDev = import.meta.env.DEV;
const isTest = import.meta.env.MODE == 'test';

const defaultOptions: ValidateUrlOptions = {
  allowLocalhost: isDev && !isTest,
};

export function validateUrl(input: string, options: ValidateUrlOptions = defaultOptions): boolean {
  try {
    const newUrl = new URL(input);
    const hasProtocol = validProtocols.includes(newUrl.protocol);
    const isLocalhost = newUrl.hostname === 'localhost';
    if (isLocalhost && options.allowLocalhost) {
      return hasProtocol;
    }

    const hostnameParts = newUrl.hostname.split('.');
    const hasValidHostname = hostnameParts.length > 1;
    const topLevelDomain = hostnameParts.pop();
    const hasValidTld = !isNil(topLevelDomain) && validTlds.includes(topLevelDomain);
    return hasProtocol && hasValidHostname && hasValidTld;
  } catch (e) {
    return false;
  }
}

export function validateUrls(urls: string[] | null | undefined): boolean {
  if (isNil(urls)) {
    return true;
  }
  return urls.every(url => validateUrl(url));
}
